import { BaseElementToSimpleSapElementMapper } from '../baseElementToSimpleSapElementMapper';
import Element, { ElementType } from '@/models/element';
import { ISimpleSapElement, SimpleSapElement } from '@/models/api/models/simpleSapElement';
import store from '@/store';

export class DrawerToSimpleSapElementMapper extends BaseElementToSimpleSapElementMapper {

    public map(element: Element): ISimpleSapElement[] {
        const elements: Element[] = store.getters.scene.elements;
        const handles = elements.filter((x) => x.type === ElementType.HANDLE);
        const code = handles.length > 0 ? 'KSS' : 'KSP';
        const dim1 = element.shape.x;
        const dim2 = this.product.depth === 455 ? 1 : 2;
        const type = this.formatType(code, dim1, dim2);
        const color = this.toColor(element);
        const drawer = SimpleSapElement.ELEMENT(type, color);
        return [drawer];
    }
}
